import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import { getfreetrialallApi } from "../../../services/authApi";
import { toast } from "react-toastify";
import {
  checkErrorMessage,
  checkResponseData,
} from "../../../components/pages/utils/utilsFunctions";

export default function ModalAlert(props) {
  const { handleFullScreen, handleOpenModalAlert, handleShowSubtitleStyleBox } =
    props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { handlePageNumber, userTypes, handleUserType } =
    useContext(MainContext);

  const getfreetrialAllFromBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      const response = await getfreetrialallApi(data);
      let resData = checkResponseData(response);
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(resData["token"]));
        let newUserType = ["freetrial_dict", ...userTypes];
        handleUserType(newUserType);
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 2000,
        });
      }
      handleOpenModalAlert();
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error("Error-getfreetrialAllFromBack", error);
    }
  };

  return (
    <div>
      <DialogTitle id="responsive-dialog-title">
        {"مخصوص کاربران ویژه"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          این قابلیت تنها برای کاربران ویژه در دسترس می باشد با کلیک بر روی دکمه
          زیر شما می توانید کاربر ویژه شوید (بدون هزینه می توان کاربر
          ویژه شد)
          <br />
          ضمنا به منظور بررسی خدمات برنامه می توانید سرویس رایگان آزمایشی را
          انتخاب کنید و به مدت 15 روز همانند کاربر ویژه از خدمات برنامه استفاده
          کنید
          <br />
          <Button
            autoFocus
            className="yn-showPackages3 yn-showPackages"
            variant="contained"
            onClick={() => {
              handlePageNumber("", 2);
              handleFullScreen.exit();
              handleOpenModalAlert();
              handleShowSubtitleStyleBox();
            }}
            color="warning"
            // size="small"
            sx={{ m: 1 }}
          >
            تبدبل به کاربر ویژه (امکان دریافت رایگان)
          </Button>
          <Button
            className="yn-freeTrial3 yn-freeTrial"
            variant="contained"
            color="info"
            size="small"
            sx={{ m: 2 }}
            onClick={() => {
              getfreetrialAllFromBack({});
            }}
          >
            دریافت سرویس آزمایشی
          </Button>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleOpenModalAlert();
          }}
        >
          بستن
        </Button>
      </DialogActions>
    </div>
  );
}
